import { Title, Text, List } from '@mantine/core'

// Renders a guide body — an array of content blocks (see content/en.js) — into
// Mantine typography. Block shapes: { p }, { h2 }, { list: [{ term, text }] }.
export default function GuideBody({ body = [] }) {
  return body.map((block, i) => {
    if (block.h2) {
      return (
        <Title key={i} order={2} mt="lg" mb="xs">
          {block.h2}
        </Title>
      )
    }
    if (block.list) {
      return (
        <List key={i} spacing="xs" mb="md">
          {block.list.map((item, j) => (
            <List.Item key={j}>
              {item.term ? (
                <>
                  <b>{item.term}</b> — {item.text}
                </>
              ) : (
                item.text
              )}
            </List.Item>
          ))}
        </List>
      )
    }
    return (
      <Text key={i} mb="md">
        {block.p}
      </Text>
    )
  })
}
